var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFuerzaOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 228.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00b7ff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-fuerza-on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_16",
    "data-name": 16
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.83,191.83a34.64,34.64,0,0,0-69.19,0c0,.59,0,1.19,0,1.78a34.64,34.64,0,0,0,69.28,0C132.88,193,132.86,192.42,132.83,191.83Zm-34.59,24A22.2,22.2,0,0,1,76,193.61c0-.6,0-1.19.08-1.78a22.19,22.19,0,0,1,44.24,0c0,.59.07,1.18.07,1.78A22.19,22.19,0,0,1,98.24,215.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.83,175.23a30.12,30.12,0,0,0-53.18,0,29.7,29.7,0,0,0-3.52,12.62c0,.52,0,1,0,1.55a30,30,0,0,0,.3,4.16h3.49a25.86,25.86,0,0,1-.33-4.16c0-.66,0-1.36.09-2.13a26.69,26.69,0,0,1,53.2,0c.06.77.09,1.47.09,2.13a27.05,27.05,0,0,1-.33,4.16h3.49a30,30,0,0,0,.29-4.16c0-.52,0-1,0-1.55h0A29.55,29.55,0,0,0,124.83,175.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.35,154.76A39.25,39.25,0,0,1,139.67,171a38.69,38.69,0,0,1,4.56,16.42c0,.66.06,1.33.06,2a38,38,0,0,1-.23,4.16h36.09l-12-38.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.19,189.4c0-.67,0-1.34.05-2A38.7,38.7,0,0,1,56.81,171a39.25,39.25,0,0,1,16.32-16.22H0l.1,38.8H52.41A40.63,40.63,0,0,1,52.19,189.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 144.61 117.83 144.61 1.65 82.23 0 144.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.65 59.8 1.65 82.23 245.75 213.28 255.12 195.88 1.65 59.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.19 110.44 36.78 101.09 52.83 87.28 70.24 96.62 54.19 110.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.06 91.58 1.65 82.23 17.7 68.42 35.11 77.77 19.06 91.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.92 129.62 72.5 120.27 88.56 106.46 105.97 115.81 89.92 129.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.26 148.59 107.84 139.25 123.89 125.43 141.31 134.78 125.26 148.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.99 167.78 143.57 158.43 159.62 144.61 177.03 153.96 160.99 167.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.96 186.01 177.54 176.66 193.59 162.85 211.01 172.2 194.96 186.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.85 204.21 211.44 194.86 227.49 181.04 244.9 190.39 228.85 204.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.07,118.53h52.44V53.65h25.76L229,36.88,200.39,7.33,193.29,0l-7.1,7.33L157.55,36.88,141.31,53.65h25.76v64.88Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFuerzaOn);
export default __webpack_public_path__ + "static/media/ic-fuerza-on.4e1a55fcfa148c651aedee49dbaf95c7.svg";
export { ForwardRef as ReactComponent };